module.exports = __webpack_public_path__ + "img/DE00634.6d48baa7.png";